import { MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';
import heroReception from '@/assets/hero-recepcao-habitus.webp';
import heroReceptionSrcset from '@/assets/hero-recepcao-habitus.webp?w=640;1024;1600&format=webp&quality=72&as=srcset';

const Hero = () => {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 md:pt-20"
    >
      {/* Background Image - LCP optimized */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroReception}
          srcSet={heroReceptionSrcset}
          sizes="100vw"
          alt="Recepção da Clínica Habitus com jardim vertical e logo"
          className="w-full h-full object-cover"
          width={1600}
          height={1200}
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/80 to-background/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-background/30" />
      </div>

      <div className="container-mobile relative z-10 py-12 md:py-20">
        <div className="max-w-2xl mx-auto text-center md:text-left md:mx-0">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 backdrop-blur-sm text-primary mb-6">
            <span className="text-sm font-medium">10 anos em Brasília</span>
          </div>

          {/* Headline */}
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-semibold text-foreground leading-tight mb-4">
            Mais de <span className="text-habitus-teal-dark">40 mil atendimentos</span> em 10 anos
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-foreground/80 mb-6 max-w-xl">
            Medicina integrativa que une ciência e cuidado humanizado para seu bem-estar completo.
          </p>

          {/* Rating */}
          <div className="flex items-center justify-center md:justify-start gap-4 mb-8 flex-wrap">
            <div className="flex items-center gap-1 text-sm text-muted-foreground">
              <MapPin className="w-4 h-4" />
              <span>Brasília, DF</span>
            </div>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <Button
              asChild
              size="lg"
              className="bg-primary hover:bg-primary/90 text-lg px-8 py-6 h-auto"
            >
              <a
                href="https://api.whatsapp.com/send?phone=5561947568717&text=Ol%C3%A1,%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20como%20funcionam%20os%20atendimentos%20da%20Cl%C3%ADnica%20Habitus!"
                target="_blank"
                rel="noopener noreferrer"
              >
                Agendar pelo WhatsApp
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="text-lg px-8 py-6 h-auto border-primary text-primary hover:bg-primary/5 backdrop-blur-sm"
            >
              <a href="#estrutura">Conhecer a Clínica</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
